import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import LoanpartRowComponent from './LoanpartRowComponent';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
@observer
class LoanpartFormComponent extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types, because map is native method
    const { loanparts, selectedLabel } = this.props.CalculationFormData.mortgageForm;
    const { loanpartError } = this.props.CalculationFormData;

    const lastIndex = loanparts.slice().length - 1;

    const loanpartErrorMessage = loanpartError ? <div className="alert-danger loanpartError">{loanpartError}</div> : '';

    let loanpartRows = loanparts.map((loanpart, i) => (
      <LoanpartRowComponent
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        index={i}
        value={loanpart}
        lastIndex={lastIndex}
      />
    ));

    /* Hide loanpartRows if no label is chosen */
    if (selectedLabel === 0) {
      loanpartRows = null;
    }

    return (
      <div className="calculation-form__loanparts ">
        {loanpartErrorMessage}

        {loanpartRows}
      </div>
    );
  }
}

LoanpartFormComponent.propTypes = {
  CalculationFormData: PropTypes.shape({
    mortgageForm: PropTypes.shape({
      labelId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      loanparts: PropTypes.arrayOf(PropTypes.number),
      loanpartsPostData: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    loanpartError: PropTypes.string,
  }),
};

LoanpartFormComponent.defaultProps = {
  CalculationFormData: {
    mortgageForm: {
      labelId: '',
      loanparts: [],
      loanpartsPostData: [],
    },
    loanpartError: '',
  },
};

export default inject('CalculationFormData', 'CalculationOutputData')(LoanpartFormComponent);
